import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutRight"><Path d="M3.5 3.5L17.5 3.5L17.5 20.5H3.5L3.5 3.5Z" stroke="currentColor"/><Path d="M20.5 3V21" stroke="currentColor"/></CentralIconBase>;
});

export default IconLayoutRight;
